<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>

        <v-card class="elevation-12" v-if="!signinOk">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Registro</v-toolbar-title>
          </v-toolbar>
          <v-card-text>

          <p v-if="signupEmail">En breve recibirà un correo electrònico en la dirección <b>{{ signupEmail }}</b> para verificar que este correo es suyo. En el correo encontrará el código para activar la contraseña.</p>
          <p>Por favor indique el código de activación y haga clic en CONTINUAR para completar el proceso de registro o modificación de contraseña</p>
          
          <v-form ref="fmSignin" v-model="valid" lazy-validation>

              <v-alert :value="error" type="warning">{{ error }}</v-alert>

              <v-text-field 
                class="pt-3"
                v-model="codigoActivacion"
                prepend-icon="lock" 
                name="codigoActivacion" 
                label="Código de activación" 
                type="text"
                required
                :rules="codigoRules">
              </v-text-field>

            </v-form>

          </v-card-text>
          <v-card-actions>            
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="goHome">Cancelar</v-btn>          
            <v-btn color="primary" @click="signin">Continuar</v-btn>
          </v-card-actions>
        </v-card>

         <v-card class="elevation-12" v-if="signinOk">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Registro</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <p>El cambio o registro de contraseña para el usuario <strong>{{ signupEmail }}</strong> se ha efectuado correctamente </p>
          </v-card-text>
          <v-card-actions>            
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="goHome">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style></style>

<script>
  import { SIGNIN_REQUEST } from '../store/actions/auth'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'signin',
    computed: {
      ...mapGetters(['authStatus']),
      ...mapState({
        signupEmail: state => state.auth.signupEmail
      })
    },
    data () {
      return {
        codigoActivacion: '',

        error: '',
        valid: true,

        codigoRules: [
          v => !!v || 'Debe indicar el código de activación',
          v => (v && v.length == 6) || 'El código de activación debe ser de 6 caracteres'
        ],

        signinOk: false
      }
    },
    methods: {
      signin: function () {
        if (this.$refs.fmSignin.validate()) {
          this.$store.dispatch(SIGNIN_REQUEST, { token: this.codigoActivacion })
          .then((response) => {
            this.email = response.EMAIL.toLowerCase()
            this.error = ''
            this.signinOk = true
          })
          .catch(error => {
            this.error = error
            this.signinOk = false
          })
        }
      },
      goHome: function() {
        this.$router.push('/')
      }
    },
  }
</script>
